/* PS AFEX S5 Recipe Galaxy — orbit chips sync with recipe preview card */
(function () {
  if (window.__PS_AFEX_S5__) return;
  window.__PS_AFEX_S5__ = true;

  function playTick(a, b, c, d) {
    if (window.PS_AFEX && window.PS_AFEX.playTick) window.PS_AFEX.playTick(a, b, c, d);
  }

  function init() {
    var galaxyWrap = document.getElementById('ps-afex-galaxyWrap');
    var recipePreview = document.getElementById('ps-afex-recipePreview');
    if (!galaxyWrap || !recipePreview) return;

    var items = galaxyWrap.querySelectorAll('.orbit-item');
    if (!items.length) return;

    var previewLink = document.getElementById('ps-afex-previewLink');
    var previewImg = document.getElementById('ps-afex-previewImg');
    var previewTitle = document.getElementById('ps-afex-previewTitle');
    var previewCopy = document.getElementById('ps-afex-previewCopy');
    var previewTime = document.getElementById('ps-afex-previewTime');
    var previewDiet = document.getElementById('ps-afex-previewDiet');

    function isMobileLayout() {
      return window.matchMedia('(max-width: 760px)').matches;
    }

    function layoutOrbits() {
      var mobile = isMobileLayout();
      galaxyWrap.classList.toggle('is-mobile-chips', mobile);

      if (mobile) {
        items.forEach(function (el) {
          el.style.left = '';
          el.style.top = '';
          el.style.transform = '';
        });
        return;
      }

      var wrapW = galaxyWrap.offsetWidth || 700;
      var radius = Math.min(190, Math.max(110, wrapW * 0.36));
      items.forEach(function (el, i) {
        var angle = (i / items.length) * 2 * Math.PI - Math.PI / 2;
        var x = Math.cos(angle) * radius;
        var y = Math.sin(angle) * radius * 0.75;
        el.style.left = 'calc(50% + ' + x + 'px)';
        el.style.top = 'calc(50% + ' + y + 'px)';
        el.style.transform = 'translate(-50%, -50%)';
      });
    }

    function setPreview(el) {
      var name = el.getAttribute('data-name') || el.textContent;
      var copy = el.getAttribute('data-copy') || '';
      var image = el.getAttribute('data-image') || '';
      var time = el.getAttribute('data-time') || '';
      var diet = el.getAttribute('data-diet') || '';
      var url = el.getAttribute('data-url') || '#';

      if (previewTitle) previewTitle.textContent = name;
      if (previewCopy) previewCopy.textContent = copy;
      if (previewTime) {
        previewTime.textContent = time;
        previewTime.hidden = !time;
      }
      if (previewDiet) {
        previewDiet.textContent = diet;
        previewDiet.hidden = !diet;
      }
      if (previewLink) previewLink.href = url;
      if (previewImg) {
        if (image) {
          previewImg.hidden = false;
          previewImg.src = image;
          previewImg.alt = name;
        } else {
          previewImg.hidden = true;
          previewImg.removeAttribute('src');
        }
      }
    }

    function preloadAdjacent(index) {
      [index - 1, index + 1].forEach(function (i) {
        if (i < 0 || i >= items.length) return;
        var src = items[i].getAttribute('data-image');
        if (!src) return;
        var img = new Image();
        img.src = src;
      });
    }

    items.forEach(function (el, index) {
      el.addEventListener('click', function () {
        playTick(500, 0.08, 'sine', 0.05);
        items.forEach(function (o) { o.classList.remove('active'); });
        el.classList.add('active');
        recipePreview.style.opacity = '0';
        setTimeout(function () {
          setPreview(el);
          preloadAdjacent(index);
          recipePreview.style.transition = 'opacity .4s ease';
          recipePreview.style.opacity = '1';
        }, 200);
      });
    });

    layoutOrbits();
    window.addEventListener('resize', layoutOrbits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
